// @flow
import React from 'react';
import injectSheet from 'react-jss';
import { S } from './shell/shellTokens';

type Props = {
  classes: Object,
  label: string,
  id: string,
  value: string,
  onChange: () => void,
  placeholder: string,
  title: string
}

function SettingRow({ classes: c, label, id, value, onChange, placeholder, title }: Props) {
  return (
    <div className={c.sectionSetting} key={id}>
      <label htmlFor={id} className={c.sectionSettingLabel}>{label}</label>
      <input
        id={id} type="text"
        className={c.sectionSettingInput} value={value || ''}
        placeholder={placeholder}
        title={title}
        onChange={e => onChange(id, e.target.value)}
      />
    </div>
  );
}

const styles = {
  sectionSetting: {
    marginBottom: '12px'
  },
  sectionSettingLabel: {
    display: 'block',
    marginBottom: '5px',
    fontSize: '12px',
    color: S.muted
  },
  sectionSettingInput: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    border: `1px solid ${S.fieldLine}`,
    borderRadius: '6px',
    padding: '7px 8px',
    fontSize: '13px',
    fontFamily: S.ui,
    color: S.fg,
    background: S.field,
    outline: 'none',
    '&:focus': { borderColor: S.fg }
  }
};

export default injectSheet(styles)(SettingRow);
